import { axiosBasic } from "../config/axios-common";

const getAllSpecialtyOptions = () => {
    return axiosBasic.get("/sam/v1/specialties/getall").then(response => {
      let specialtyOption = response.data.map((row: any) => {
        return {
          "Id": row.id,
          "Text": row.description,
          "Value": row.id
        }
      });
      return specialtyOption
    })
    .catch(e => {
      console.log(e)
    });
};
  
const getAllTitleOptions = () => {
    return axiosBasic.get("/sam/v1/title/getall").then(response => {
      let titleOption = response.data.map((row: any) => {
        return {
          "Id": row.id,
          "Text": row.description,
          "Value": row.id
        }
      });
      return titleOption
    })
    .catch(e => {
      console.log(e)
    });
};

const getAllOperationAreaOptions = () => {
    return axiosBasic.get("/sam/v1/operationarea/getall").then(response => {
      let operationAreaOption = response.data.map((row: any) => {
        return {
          "Id": row.id,
          "Text": row.description,
          "Value": row.id
        }
      });
      return operationAreaOption
    })
    .catch(e => {
      console.log(e)
    });
};

 


const exportedObject = {
    getAllSpecialtyOptions,
    getAllTitleOptions,
    getAllOperationAreaOptions,
};
  
  
  export default exportedObject